import classNames from 'classnames';

import dibsCss from 'dibs-css';

const ACTION_RESULT_TOAST_PROPS = {
    type: 'basic',
    position: 'bottomLeft',
    showCloseButton: false,
    hideTimeoutBar: true,
    closeAfterTimeout: 4000,
    withCustomBackground: true,
    zIndex: 'aboveOverlay',
    className: classNames(dibsCss.bgGreen900, dibsCss.textWhite),
} as const;

export { ACTION_RESULT_TOAST_PROPS };
